import { createApp} from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/index.css';
import VueScrollTo from 'vue-scrollto'
import axios from 'axios'
// import VueCompositionApi from "@vue/composition-api";

// Vue.config.productionTip = false

createApp(App).use(router,VueScrollTo,axios).mount('#app')

// new Vue({
//     router,
//     render: h => h(App),
// }).$mount('#app')